import * as React from "react";
import type { SVGProps } from "react";
const SvgScreen2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4FD08F"
      d="M13.25 22.75H7A5.75 5.75 0 0 1 1.25 17V7A5.75 5.75 0 0 1 7 1.25h6.25zm9.5-5.75A5.75 5.75 0 0 1 17 22.75h-2.25v-8h8zM17 1.25A5.75 5.75 0 0 1 22.75 7v6.25h-8v-12z"
    />
  </svg>
);
export default SvgScreen2;
